// Auth types & token helpers

export interface AuthUser {
  id: string
  email: string
  role: string
  roleName?: string
  /** Geçici şifreyle açılan hesap: şifre değiştirilmeden uygulamaya girilmez. */
  mustChangePassword?: boolean
}

/** Personel rolü — yalnız kendi görevleri ve görevli olduğu dosyalar. */
export const PERSONEL_ROLU = "personnel"

/** Girişten sonra açılan sayfa. */
export function girisSonrasiYol(user: Pick<AuthUser, "role" | "mustChangePassword">): string {
  if (user.mustChangePassword) return "/sifre-degistir"
  return user.role === PERSONEL_ROLU ? "/gorevlerim" : "/"
}

export interface TokenPair {
  accessToken: string
  refreshToken: string
}

export interface LoginResponse {
  user: AuthUser
  tokens: TokenPair
}

export interface LoginPayload {
  email: string
  password: string
}

export interface RegisterPayload {
  email: string
  password: string
  roleId: string
}

const ACCESS_TOKEN_KEY = "audex_access_token"
const REFRESH_TOKEN_KEY = "audex_refresh_token"
const USER_KEY = "audex_user"

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setTokens(tokens: TokenPair) {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken)
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken)
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export function getStoredUser(): AuthUser | null {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function setStoredUser(user: AuthUser) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}
